import { config } from "/app.config"

export const GOOGLE_TAG_MANAGER_ID = process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID

export const isGtmEnabled = () => {
  return GOOGLE_TAG_MANAGER_ID && GOOGLE_TAG_MANAGER_ID.length && config.isZeno
}

export const trackGtmEvent = (eventData) => {
    try {
        if (isGtmEnabled() && window.dataLayer) {
            window.dataLayer.push(eventData);
        }
    } catch (e) {
        console.log("[GTM] Error: ", e);
    }
}

/**
 * Conversion pushes for a verified Stripe checkout (see docs/checkout-conversion-page.md).
 * Pushes the legacy `paid_plan_created` event (pricing experiment reads it) and a GA4-shaped
 * `purchase` event that ad tags (Google Ads, Meta Pixel) trigger on. Caller is responsible for
 * per-session dedupe (`trackPaidPlanCreatedOnce`) so a refresh never double counts.
 *
 * @param {Object} conversion
 * @param {string} conversion.sessionId Stripe Checkout session id — becomes `transaction_id` / Meta `eventID`
 * @param {string} conversion.flow `onboarding` | `upgrade` | `podcast_bot`
 * @param {string|null} conversion.accountKey
 * @param {string|null} conversion.plan main plan type, lower-cased
 * @param {number} conversion.value amount charged (major units), 0 for trials
 * @param {string} conversion.currency ISO code, upper-cased
 * @param {string|null} conversion.billingPeriod `month` | `year`
 * @param {boolean} conversion.isTrial
 * @param {Array<{priceId?: string, productName?: string}>} conversion.subscriptionResults
 */
export const trackCheckoutConversion = ({
    sessionId,
    flow,
    accountKey,
    plan,
    value,
    currency,
    billingPeriod,
    isTrial,
    subscriptionResults = [],
}) => {
    trackGtmEvent({
        event: "paid_plan_created",
        flow,
        plan,
        value,
        currency,
        billing_period: billingPeriod,
        ...(isTrial && { is_trial: true }),
    });

    // GA4 recommends clearing the previous ecommerce object before pushing a new one.
    trackGtmEvent({ ecommerce: null });
    trackGtmEvent({
        event: "purchase",
        flow,
        plan,
        is_trial: !!isTrial,
        billing_period: billingPeriod,
        account_key: accountKey || null,
        ecommerce: {
            transaction_id: sessionId,
            value,
            currency,
            items: subscriptionResults
                .filter((result) => result.priceId || result.productName)
                .map((result) => ({
                    item_id: result.priceId || null,
                    item_name: result.productName || null,
                    quantity: 1,
                })),
        },
    });
}